module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete-container"
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmpty),
      expression: "isEmpty"
    }],
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty),
      expression: "isDirty"
    }],
    staticClass: "fa fa-times",
    on: {
      "click": _vm.reset
    }
  })], _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    class: _vm.inputClass,
    attrs: {
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "autocomplete": "off",
      "name": _vm.name,
      "id": _vm.name,
      "hint": _vm.hint,
      "persistent-hint": _vm.persistentHint
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": _vm.onInputSelect,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onSelect($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.reset($event)
      }],
      "blur": _vm.reset,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.updateTimeout]
    }
  }), _vm._v(" "), (!_vm.hideDetails) ? _c('label', {
    staticClass: "indigo--text details-label text-none"
  }, [_vm._v(_vm._s(_vm.searchDescription))]) : _vm._e(), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items),
      expression: "items"
    }],
    staticClass: "pl-0"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "auto-label",
      class: _vm.activeClass(index),
      on: {
        "mousedown": _vm.onSelect,
        "mousemove": function($event) {
          return _vm.setActive(index)
        }
      }
    }, [_c('strong', {
      domProps: {
        "textContent": _vm._s(item[_vm.criteria])
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item[_vm.description])
      }
    })])
  }), 0)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-695689b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-695689b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/autocomplete/Autocomplete.vue
// module id = 790
// module chunks = 1